export default "__VITE_ASSET__30gBEHGf__"